import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_info-productpagevideodetails-view';
/**
 * Details of how many videos are shown in each PDP view.
 */
export function trackProductInfoProductpagevideodetailsView(json, json22, Testname3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { json, json22, Testname3 },
    });
}
